import fetch from 'isomorphic-fetch';
import { config } from '../../../../core/config/config';
import store from '../../../../core/redux/store';

export const getDriversAssignedToHub = async (
  promisor_id: string,
  contract_id: string,
  hub_id: string
): Promise<any> => {
  try {
    const state = store.getState();
    const token = state.token.token;

    const query = new URLSearchParams({ promisor_id, hub_id });
    const uri = `${config.uri.base_url}/contracts/${contract_id}/drivers-assigned-to-hub?${query}`;
    const options = {
      method: 'GET',
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json'
      })
    };

    const response = await fetch(uri, options);
    const result = await response.json();

    if (!response.ok) {
      throw new Error(result.message || 'Something went wrong');
    }

    return result;
  } catch (err) {
    throw err;
  }
};
